import { render } from "./EntitiesPortal.vue?vue&type=template&id=0eb47517&scoped=true"
import script from "./EntitiesPortal.vue?vue&type=script&lang=js"
export * from "./EntitiesPortal.vue?vue&type=script&lang=js"

import "./EntitiesPortal.vue?vue&type=style&index=0&id=0eb47517&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0eb47517"]])

export default __exports__